import React, { ReactElement } from "react";

import { Stack, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";

import { ReduxHiddenDataField } from "../../../../components/Redux/ReduxHiddenDataField";
import { ReduxTextField } from "../../../../components/Redux/TextField";
import SettingSection from "../../../../components/SettingSection";
import {
  getClusterFormProperty,
  getSettingsFormProperty,
  setClusterFormProperty,
  setSettingsFormError,
  setSettingsFormProperty,
} from "../../../../slices/settings";
import { validateDuration } from "../../../../validators/duration";
import { validUrl } from "../../../../validators/url";
import { SectionProps } from "../../../routes/components/edit_sections/common";

export const General = ({
  readonly,
  tabValue,
  refresh,
}: SectionProps): ReactElement => {
  return (
    <Container component={Paper} maxWidth={false} disableGutters={true}>
      <Stack key={tabValue + refresh} spacing={1} sx={{ m: 3 }}>
        <Typography id={tabValue} variant="h2" sx={{ pt: 2 }}>
          General
        </Typography>
        <Divider />
        <SettingSection label="Cluster Name" docsKey="cluster-settings-name">
          <ReduxTextField
            disabled={readonly}
            setter={setClusterFormProperty}
            getter={getClusterFormProperty}
            errorHandler={setSettingsFormError}
            path="name"
            fullWidth
          />
        </SettingSection>
        <Divider />

        <SettingSection
          label="Databroker Storage Connection String"
          docsKey="data-broker-storage-connection-string"
        >
          <ReduxHiddenDataField
            disabled={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            path="databrokerStorageConnection"
            validator={validUrl}
            fullWidth
          />
        </SettingSection>
        <Divider />

        <SettingSection label="Session Lifetime" docsKey="expires">
          <ReduxTextField
            disabled={readonly}
            fullWidth
            path="cookieExpire"
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateDuration}
          />
        </SettingSection>
      </Stack>
    </Container>
  );
};
